// src/pages/webSite/categories/WebSiteCategories.js
// صفحة عرض جميع التصنيفات - تعرض التصنيفات في شبكة مع إمكانية النقر للتصفح

// استيراد المكتبات والأدوات المطلوبة
import { useEffect, useState } from "react"; // هووكس React
import { Container } from "react-bootstrap"; // حاوية Bootstrap
import { useNavigate } from "react-router-dom"; // للتنقل بين الصفحات
import { CATEGORIES } from "../../../API/Api"; // رابط API للتصنيفات
import { Axios } from "../../../API/Axios"; // عميل Axios المُعد
import StringSlice from "../../../Helpers/StringSlice"; // دالة تقصير النصوص
import Skeltonshow from "../../../components/website/sekelton/skelton"; // مكون骨架 (تحميل)
import { useLanguage } from "../../../Context/LanguageContext"; // هوك اللغة
import SectionHeader from "../../../components/website/Products/ProductCard/SectionHeader"; // عنوان القسم
import "./WebSiteCategories.css"; // أنماط الصفحة

// ================ المكون الرئيسي ================
export default function WebsiteCategories ()
{
    // هوك اللغة للحصول على النصوص المترجمة واتجاه الكتابة
    const { t, lang, dir } = useLanguage(); // الأسماء الصحيحة من الـ Context
    const navigate = useNavigate(); // للتنقل بين الصفحات

    // حالات الصفحة
    const [ categories, setCategories ] = useState( [] ); // قائمة التصنيفات
    const [ loading, setLoading ] = useState( true ); // حالة التحميل

    // ===== جلب التصنيفات من API =====
    useEffect( () =>
    {
        // إرسال طلب GET لجلب جميع التصنيفات
        Axios.get( `${ CATEGORIES }` )
            .then( ( res ) => setCategories( res.data ) ) // تخزين البيانات
            .finally( () => setLoading( false ) ); // إيقاف حالة التحميل
    }, [] ); // تشغيل مرة واحدة عند تحميل المكون

    // ===== دالة النقر على التصنيف =====
    const handleCategoryClick = ( item ) =>
    {
        // التنقل إلى صفحة التصنيف مع تمرير عنوان التصنيف
        navigate( `/category/${ item.id }`, { state: { categoryTitle: item.title } } );
    };

    // ===== عرض التصنيفات كبطاقات =====
    const showCategories = categories.map( ( item, index ) => (
        <div
            className="wc-card"
            key={ item.id }
            style={ { animationDelay: `${ index * 0.06 }s` } } // تأثير متدرج للظهور
            onClick={ () => handleCategoryClick( item ) } // النقر للتنقل
            role="button" // دور زر لسهولة الوصول
            tabIndex={ 0 } // قابلية التركيز
            onKeyDown={ ( e ) => e.key === "Enter" && handleCategoryClick( item ) } // دعم Enter
        >
            {/* قسم الصورة */ }
            <div className="wc-card-media">
                <img
                    className="wc-card-img"
                    src={ item.image }
                    alt={ item.title }
                    loading="lazy" // تحميل متأخر لتحسين الأداء
                />
                <div className="wc-card-overlay" /> {/* تراكب شفاف */ }
            </div>

            {/* معلومات التصنيف */ }
            <div className="wc-card-body">
                <p className="wc-card-title">{ StringSlice( item.title, 16 ) }</p>
                <span className="wc-card-link">
                    { lang === "ar" ? "تسوقي الآن" : "Shop now" }
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </div>
        </div>
    ) );

    // ================ عرض الواجهة ================
    return (
        <div className="wc-page py-5" dir={ dir }> {/* اتجاه النص حسب اللغة */ }
            <Container>
                {/* عنوان الصفحة والوصف */ }
                <SectionHeader
                    title={ t( 'categoriesPage.title' ) }
                    subtitle={ t( 'categoriesPage.subtitle' ) }
                />

                {/* شبكة التصنيفات */ }
                <div className="wc-grid">
                    { loading ? (
                        // عرض骨架 أثناء التحميل
                        <Skeltonshow length="15" height="220px" baseColor="#f0f1f4" />
                    ) : (
                        // عرض التصنيفات
                        showCategories
                    ) }
                </div>
            </Container>
        </div>
    );
}